<template>
  <svg :viewBox="viewBox" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height">
    <path
      d="M212 50.5q43.5 0 81.5 16.5t66.5 44.75T405 178t16.5 81.5T405 341t-45 66.5-66.5 45T212 469t-81.5-16.5-66.25-45T19.5 341 3 259.5 19.5 178t44.75-66.25T130.5 67 212 50.5zm104 164q14.5-11 25.5-26.5-7 3-14.25 5T312 196q8-5 14-12.25t8.5-15.75q-7.5 4-15.5 7.25T302.5 180q-7-7-16.5-11.5t-21-4.5q-10.5 0-19.75 4t-16 11-10.75 16.25-4 19.75q0 3 .25 6t.75 5.5Q184 225 157 211t-46-37.5q-7 11.5-7 25.5 0 13 6.25 24.25t16.25 18.25q-13-1-23-6.5v.5q0 19 11.75 32.75t29.25 17.25q-3.5 1-6.75 1.5t-6.75.5q-2.5 0-4.75-.25t-4.75-.75q5 15 17.75 25t29.75 10q-13 10.5-29.25 16.25T106 343.5q-3.5 0-6.5-.25t-6-.75q17 11 36.75 17t41.25 6q35 0 62-13.25t45.25-34 27.75-46.5T316 221v-6.5z"
      :fill="fillColor"
    />
  </svg>
</template>

<script>
export default {
  name: "Twitter",
  props: {
    width: {
      type: String,
      default: "24",
    },
    height: {
      type: String,
      default: "24",
    },
    viewBox: {
      type: String,
      default: "0 0 425 512",
    },
    fillColor: {
      type: String,
      default: "#0078c1",
    },
  },
};
</script>
